import { useTranslation } from 'react-i18next';
import Disclosure from '../components/common/Disclosure.jsx';

const CONTACT_EMAIL = 'contact@hermeneuticscommons.org';

// Help entries grouped into themed sections. Each id maps to a
// `help.items.<id>` block in the translation files ({ q, a: [paragraphs] }).
const SECTIONS = [
  { group: 'start', items: ['what', 'register', 'signIn', 'signOut'] },
  { group: 'account', items: ['profile'] },
  {
    group: 'contribute',
    items: ['bibEntry', 'bibCorrection', 'scholar', 'organization', 'teaching', 'announcement'],
  },
  { group: 'after', items: ['afterSubmit'] },
  { group: 'more', items: ['language', 'contact'] },
];

export default function Help() {
  const { t } = useTranslation();

  return (
    <article className="mx-auto max-w-3xl px-6 pb-20 pt-28">
      <header className="mb-8">
        <div className="section-label">{t('help.label')}</div>
        <h1 className="font-serif text-4xl font-semibold text-cream">
          {t('help.heading')}
        </h1>
        <p className="mt-4 text-base leading-relaxed text-ink-primary">
          {t('help.intro')}
        </p>
      </header>

      <div className="space-y-12">
        {SECTIONS.map(({ group, items }) => (
          <section key={group}>
            <h2 className="mb-4 font-serif text-2xl font-semibold text-gold-light">
              {t(`help.groups.${group}`)}
            </h2>
            <div className="space-y-3">
              {items.map((id) => {
                const paragraphs = t(`help.items.${id}.a`, { returnObjects: true });
                const body = Array.isArray(paragraphs) ? paragraphs : [paragraphs];
                return (
                  <Disclosure key={id} question={t(`help.items.${id}.q`)}>
                    {body.map((p, i) => (
                      <p key={i}>{p}</p>
                    ))}
                    {id === 'contact' && (
                      <p>
                        <a
                          href={`mailto:${CONTACT_EMAIL}`}
                          className="text-gold-light hover:underline"
                        >
                          {CONTACT_EMAIL}
                        </a>
                      </p>
                    )}
                  </Disclosure>
                );
              })}
            </div>
          </section>
        ))}
      </div>
    </article>
  );
}
